var _effectorFileName = "/builds/gmini/front-ui-kit/src/TextField/TextField.styled.ts";
import styled, { css } from 'styled-components';
import { HighlightOff } from '../icons';
export const Input = styled.input`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: ${props => props.background ? props.background : 'rgba(53, 59, 96, 0.05)'};
  font-family: Roboto, sans-serif;
  color: #353b60;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.1px;
  outline: none;
  padding: 10px 10px 10px 12px;
  transition: all ease-out 0.2s;
  border: ${props => props.error ? '1px solid #D9575E' : '1px solid transparent'};

  ${props => props.clearable && css`
      padding-right: 32px;
    `}

  &::placeholder {
    color: rgba(53, 59, 96, 0.4);
    font-weight: 500;
  }

  &:hover {
    ${props => !props.disabled && css`
        border: 1px solid #c5c6d1;
      `}
  }

  &:focus {
    background: #fff;
    box-shadow: 0px 5px 10px rgba(53, 60, 96, 0.1);
    border: 1px solid #4c5ecf;
  }

  ${props => props.disabled && css`
      color: rgba(53, 59, 96, 0.2);
      border: 1px solid transparent;
      background: rgba(255, 255, 255, 0.5);

      &::placeholder {
        color: rgba(53, 59, 96, 0.2);
      }
    `}
`;
export const ResetButton = styled(HighlightOff)`
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto 8px auto 0;
  z-index: 1;
  background: #f5f5f7;
  transition: all ease-out 0.2s;

  path:first-child {
    transition: ease-out 0.2s;
    fill: rgba(53, 59, 96, 0.25);
  }

  &:hover {
    path:first-child {
      fill: #353b60;
    }
  }

  &:focus {
    path:first-child {
      fill: #00003d;
    }
  }
`;
export const InputWrapper = styled.div`
  width: 100%;
  height: 40px;
  position: relative;

  ${Input}:focus + ${ResetButton} {
    background: #fff;
  }
`;